<template>
  <div class="aboutRange">
    <div>
      <img src="../assets/images/picture_03.png" alt="">
      <div class="ideaText">
        <div class="fz28">“行业有界， 而保险无界”</div>
      </div>
    </div>
    <div class="compText">横跨物流、制造、生活服务、医疗健康等领域，越来越多的头部企业选择携手盛唐中融，积极探索合作场景，以创新创造价值。</div>
    <div class="colorTitle">
      <span>///</span> 中石化旗下易派客平台 <span>///</span>
    </div>
    <div>
      <img src="../assets/images/picture_04.png" alt="">
    </div>
    <div class="colorTitle">
      <span>///</span> 中国建材-我找车平台 <span>///</span>
    </div>
    <div class="compText">
      “我找车”网络货运平台是中建材集团控股的“物流+ 电商+ 信息技术”为一体的专业化平台，业务覆盖全国28 省市，入驻车辆超30 万辆，入驻货主超800家，入驻承运商30000+，致力于打造全国性现代物流网络。
      <br>
      该平台是中建材集团旗下“我找车”物流平台打造的综合保险服务品牌，集科技、产品、服务为一体优势，具备产品集成与定制能力，作为我找车供应链服务的核心环节之一，将充分发挥保险金融杠杆的特性，为我找车平台上的关联方企业及其员工保驾护航。
    </div>
    <div>
      <img src="../assets/images/picture_05.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutRange',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.aboutRange {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 30px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 192px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }
}
</style>